import React, { useCallback, useState } from "react";
import { ReloadOutlined } from "@ant-design/icons";
import { FiPrinter } from "react-icons/fi";
import { useIntl } from "react-intl";
import {
  Actions,
  ButtonFormConfirm,
  ButtonProtocol,
  Container,
  CredentialsListContainer,
  CredentialsListLabel,
  FooterContainer,
  HeaderModal,
  HeaderModalContainer,
  IconButton,
  Message,
  ModalSubTitle,
  ModalTitle,
  ModalWithdrawalAndDisassociate,
  StyledInput,
  SuccessModal,
} from "./styles";
import back from "../../components/Icons/back.svg";
import { Form, notification, Select, Tooltip } from "antd";
import ReactInputMask from "react-input-mask";
import api from "../../../../service";
import { useDispatch, useSelector } from "react-redux";
import { SubTitle } from "../../Services/style";
import { FaCheckCircle, FaArrowDown } from "react-icons/fa";
import { useEffect } from "react";
import { DotIcon } from "../../ServicePanel/card-icons";
import {
  StyledDDISelect,
  StyledFormItem,
  TelephoneSpan,
  FlagOption,
  PhoneErrorText,
} from "../../../../components/ModalNewCollaborator/styles";
import { Flex } from "../../Services/Sales/PurchaseSummary/style";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import pt from "react-phone-number-input/locale/pt.json";
import flags from "react-phone-number-input/flags";
import { verifyDefaulter } from "../../../../redux/modules/defaulters/actions";
import generateHeaders from "../../../../utils/generateHeaders";
import { base64ToArrayBuffer, mergePdfs } from "../../../../utils/file";
import printJS from "print-js";
import ConfirmationModalContent from "../ConfirmationModalContent";
import PrintCredential from "../PrintCredential";
import { DEFAULT_DDI_COUNTRY_VALUE } from "../../../../utils/declarationConstants";

const { Option } = Select;
const { TextArea } = StyledInput;

const DisassociateAndWithdrawal = ({
  selectedRowKeys,
  fetchData,
  setSelectedRows,
  companyNameCredential,
  onWithdrawnNow,
  onPrintedNow,
}) => {
  const intl = useIntl();
  const [showModal, setShowModal] = useState(false);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const { token } = useSelector((state) => state.auth);
  const { isDefaulter, isLoading } = useSelector((state) => state.defaulters);
  const contractNumber = localStorage.getItem("serviceContractNumber");
  const dispatch = useDispatch();

  const [withdrawalSuccessModalView, setWithdrawalSuccessModalView] =
    useState(false);
  const [secondFileData, setSecondFileData] = useState(null);
  const [disassociateSuccessModalView, setDisassociateSuccessModalView] =
    useState(false);
  const [rowIds, setRowIds] = useState([]);

  useEffect(() => {
    setRowIds(selectedRowKeys.map((row) => row.id));
  }, [selectedRowKeys]);

  useEffect(() => {
    if (contractNumber) {
      dispatch(verifyDefaulter({ contractNumber }));
    }
  }, [contractNumber, dispatch]);

  const onFinishDisassociate = useCallback(async () => {
    try {
      const response = await api.post(
        "/accreditation/admin/delete",
        {
          credentialIds: rowIds,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        fetchData();
        setSelectedRows([]);
      }

      notification.success({
        description: intl.formatMessage({ id: "disassociation_success" }),
      });
    } catch (error) {
      notification.error({
        message: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: "api.error." + (error.response?.data?.code || "unknown"),
        }),
      });
    } finally {
      setDisassociateSuccessModalView(false);
    }
  }, [rowIds, selectedRowKeys, token, intl, fetchData, setSelectedRows]);

  const modalDisassociate = (
    <ModalWithdrawalAndDisassociate
      footer={[
        <>
          <ButtonFormConfirm
            onClick={() => setDisassociateSuccessModalView(false)}
            style={{ border: "none" }}
          >
            {intl.formatMessage({ id: "cancel" })}
          </ButtonFormConfirm>
          <ButtonFormConfirm
            loading={loading}
            onClick={() => onFinishDisassociate()}
            style={{
              backgroundColor: "rgba(6, 142, 195, 1)",
              color: "rgba(255, 255, 255, 1)",
            }}
          >
            {intl.formatMessage({ id: "confirm" })}
          </ButtonFormConfirm>
        </>,
      ]}
      width={selectedRowKeys.length > 10 ? 512 : 450}
      height="auto"
      visible={disassociateSuccessModalView}
      closable={false}
    >
      <HeaderModal>
        <ReloadOutlined
          style={{ fontSize: "18px", color: "rgba(6, 142, 195, 1)" }}
        />
        <ModalTitle>
          {intl.formatMessage({ id: "disassociate_credential" })}
        </ModalTitle>
      </HeaderModal>
      {selectedRowKeys.length > 10 ? (
        <>
          <ModalSubTitle>
            {intl.formatMessage({
              id: "confirm_disassociation_of_",
            })}{" "}
            <strong>{selectedRowKeys.length}</strong>{" "}
            {intl.formatMessage({ id: "credentials_selected" })}
          </ModalSubTitle>
          <br />
          <ModalSubTitle style={{ fontWeight: "bold" }}>
            {intl.formatMessage({ id: "this_action_cannot_be_undone" })}
          </ModalSubTitle>
        </>
      ) : (
        <>
          <ModalSubTitle>
            {intl.formatMessage({
              id: "confirm_disassociation_of_credentials",
            })}
          </ModalSubTitle>
          <br />
          <ModalSubTitle style={{ fontWeight: "bold" }}>
            {intl.formatMessage({ id: "this_action_cannot_be_undone" })}
          </ModalSubTitle>
          <CredentialsListContainer>
            {selectedRowKeys.map((row) => (
              <CredentialsListLabel key={row.id}>
                • {row.collaboratorName}
              </CredentialsListLabel>
            ))}
          </CredentialsListContainer>
        </>
      )}
    </ModalWithdrawalAndDisassociate>
  );

  return (
    <>
      {modalDisassociate}

      {!isLoading && (
        <PrintCredential
          defaulter={isDefaulter}
          fetchData={fetchData}
          open={showPrintModal}
          setOpen={setShowPrintModal}
          selectedRowKeys={selectedRowKeys}
          setSelectedRows={setSelectedRows}
          companyNameCredential={companyNameCredential}
          isFirstPrint={true}
          onPrintedNow={onPrintedNow}
        />
      )}

      {!isLoading && (
        <Withdrawal
          defaulter={isDefaulter}
          fetchData={fetchData}
          open={showModal}
          setOpen={setShowModal}
          selectedRowKeys={selectedRowKeys}
          setSecondFileData={setSecondFileData}
          setSelectedRows={setSelectedRows}
          setWithdrawalSuccessModalView={setWithdrawalSuccessModalView}
          companyNameCredential={companyNameCredential}
          onWithdrawnNow={onWithdrawnNow}
        />
      )}
      <SuccessModal
        visible={withdrawalSuccessModalView}
        closable={false}
        footer={[
          <div>
            <ButtonProtocol
              type="primary"
              onClick={() => {
                setWithdrawalSuccessModalView(false);
                setSecondFileData(null);
              }}
              style={{
                backgroundColor: "rgba(6, 142, 195, 1)",
              }}
            >
              {intl.formatMessage({ id: "close" })}
            </ButtonProtocol>

            <ButtonProtocol
              onClick={() => {
                if (secondFileData) {
                  printJS({
                    printable: secondFileData.file,
                    type: "pdf",
                    base64: true,
                  });
                }

                setWithdrawalSuccessModalView(false);
              }}
              style={{ border: "none", marginTop: "10px", color: "#002244" }}
            >
              <FiPrinter /> {intl.formatMessage({ id: "print_protocol" })}
            </ButtonProtocol>
          </div>,
        ]}
      >
        <HeaderModalContainer>
          <FaCheckCircle style={{ fontSize: "72px" }} color="#002244" />
          <SubTitle>
            {intl.formatMessage({ id: "withdrawal_success_message" })}
          </SubTitle>
        </HeaderModalContainer>
      </SuccessModal>
      <Container>
        <Message>
          {selectedRowKeys.length > 0 ? (
            <>
              <span>
                {intl.formatMessage({
                  id: "selected_credentials",
                })}
              </span>
              <span style={{ fontWeight: "bold", marginLeft: "5px" }}>
                {String(selectedRowKeys.length).padStart(2, "0")}
              </span>
            </>
          ) : (
            intl.formatMessage({
              id: "select_at_least_one_credential_to_print_withdraw_or_disassociate",
            })
          )}
        </Message>
        <Actions>
          <Tooltip
            title={intl.formatMessage({ id: "print_credential_title" })}
            placement="top"
          >
            <span style={{ display: "inline-flex" }}>
              <IconButton
                onClick={() => setShowPrintModal(true)}
                disabled={selectedRowKeys.length === 0}
                active={selectedRowKeys.length > 0}
              >
                <FiPrinter />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip
            title={intl.formatMessage({ id: "withdraw_credential" })}
            placement="top"
          >
            <span style={{ display: "inline-flex" }}>
              <IconButton
                onClick={() => setShowModal(true)}
                disabled={selectedRowKeys.length === 0}
                active={selectedRowKeys.length > 0}
              >
                <FaArrowDown />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip
            title={intl.formatMessage({ id: "disassociate_credential" })}
            placement="top"
          >
            <span style={{ display: "inline-flex" }}>
              <IconButton
                onClick={() => setDisassociateSuccessModalView(true)}
                disabled={selectedRowKeys.length === 0}
                active={selectedRowKeys.length > 0}
              >
                <ReloadOutlined />
              </IconButton>
            </span>
          </Tooltip>
        </Actions>
      </Container>
    </>
  );
};

export default DisassociateAndWithdrawal;

export function Withdrawal({
  defaulter,
  open,
  setOpen,
  selectedRowKeys,
  setSelectedRows,
  fetchData,
  setSecondFileData,
  setWithdrawalSuccessModalView,
  companyNameCredential,
  onWithdrawnNow,
}) {
  const [isDefaulter, setIsDefaulter] = useState(defaulter);
  const [currentStep, setCurrentStep] = useState(1);
  const intl = useIntl();
  const [form] = Form.useForm();
  const [countryList, setCountryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const { token } = useSelector((state) => state.auth);

  useEffect(() => {
    const reactCountries = getCountries().map((country) => {
      const code = `+${getCountryCallingCode(country)}`;
      const countryName = intl.locale === "en" ? en[country] : pt[country];
      return {
        label: `${code} - ${countryName}`,
        value: code,
        name: countryName,
        key: `${code}-${country}`,
        countryCode: country,
      };
    });
    setCountryList(reactCountries.sort((a, b) => a.name.localeCompare(b.name)));
  }, [intl.locale]);

  useEffect(() => {
    form.setFieldValue("companyNameCredential", companyNameCredential);
  }, [companyNameCredential, form]);

  useEffect(() => {
    if (open) {
      form.setFieldValue("ddi", DEFAULT_DDI_COUNTRY_VALUE);
    }
  }, [open, form]);

  const reset = useCallback(() => {
    setLoading(false);
    fetchData();
    setCurrentStep(1);
    setSelectedRows([]);
    setIsDefaulter(defaulter);
    form.resetFields();
  }, [defaulter, fetchData, setSelectedRows, form]);

  const onFinishWithdraw = useCallback(async () => {
    try {
      const options = generateHeaders(token);
      setLoading(true);

      const credentialIds = selectedRowKeys.map((item) => item.id);
      const values = await form.validateFields();

      if (values?.reason) {
        await api.post(
          "/admin/accreditation/print-override",
          {
            credentialIds,
            reason: values.reason,
          },
          options
        );
      }

      const sanitizedValues = JSON.stringify({
        phone: `+${values.ddi.replace(/\D/g, "")}${values.telephone.replace(
          /\D/g,
          ""
        )}`,
        email: values.email,
        name: values.withdrawnBy,
        credentialCompanyName: values.companyNameCredential,
        credentialIds,
        eventId: localStorage.getItem("serviceEventId"),
        opportunityId: localStorage.getItem("serviceOpportunityId"),
        userId: localStorage.getItem("serviceSystemUserId"),
        printCredential: true,
        withdrawCredential: true,
      });

      const response = await api.post(
        "/credential-reports/staff-withdraw",
        sanitizedValues,
        options
      );

      setOpen(false);

      const credentialReports = response.data?.credentialReports || [];
      const protocolReport = response.data?.protocolReport || null;

      if (credentialReports.length > 0) {
        const arrayBuffers = credentialReports.map((apiResult) =>
          base64ToArrayBuffer(apiResult.file)
        );

        const base64String = btoa(
          [].reduce.call(
            new Uint8Array(await mergePdfs(arrayBuffers)),
            (p, c) => p + String.fromCharCode(c),
            ""
          )
        );

        printJS({
          printable: base64String,
          type: "pdf",
          base64: true,
        });
      }

      if (onWithdrawnNow) {
        onWithdrawnNow(credentialIds);
      } else if (protocolReport?.id) {
        setSecondFileData(protocolReport);
        setTimeout(() => {
          setWithdrawalSuccessModalView(true);
        }, 0);
      }

      reset();
    } catch (error) {
      notification.error({
        message: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: "api.error." + (error.response?.data?.code || "unknown"),
        }),
      });
      setLoading(false);
    }
  }, [
    form,
    reset,
    selectedRowKeys,
    setOpen,
    setSecondFileData,
    setWithdrawalSuccessModalView,
    token,
    intl,
    onWithdrawnNow,
  ]);

  const handleCloseModal = () => {
    reset();
    setOpen(false);
  };

  const handleDefaulterConfirmation = () => {
    setIsDefaulter(false);
  };

  return (
    <ModalWithdrawalAndDisassociate
      width={658}
      height="auto"
      closable={false}
      onCancel={handleCloseModal}
      visible={open}
      footer=""
      destroyOnClose
      centered
    >
      {!isDefaulter && (
        <div>
          <HeaderModal>
            <div className="icon">
              <FiPrinter
                style={{ fontSize: "18px", color: "rgba(6, 142, 195, 1)" }}
              />
            </div>
            <ModalTitle>
              {intl.formatMessage({ id: "withdraw_credential" })}
            </ModalTitle>
          </HeaderModal>
          {currentStep === 1 ? (
            <>
              <ModalSubTitle>
                {intl.formatMessage({
                  id: "confirm_withdrawal_of_credentials",
                })}
              </ModalSubTitle>
              <br />
              <ModalSubTitle style={{ fontWeight: "bold" }}>
                {intl.formatMessage({ id: "this_action_cannot_be_undone" })}
              </ModalSubTitle>
              <CredentialsListContainer>
                {selectedRowKeys.map((row) => (
                  <CredentialsListLabel key={row.id}>
                    <DotIcon color="#D9D9D9" size={7} />
                    {row.collaboratorName}
                  </CredentialsListLabel>
                ))}
              </CredentialsListContainer>
            </>
          ) : (
            <Form form={form} onFinish={onFinishWithdraw} layout="vertical">
              <StyledFormItem
                rules={[
                  {
                    required: true,
                    message: intl.formatMessage({ id: "error.field_required" }),
                  },
                ]}
                label={intl.formatMessage({ id: "company_name_credential" })}
                name="companyNameCredential"
              >
                <StyledInput
                  placeholder={intl.formatMessage({
                    id: "company_name_credential",
                  })}
                />
              </StyledFormItem>

              {defaulter && (
                <StyledFormItem
                  label={intl.formatMessage({ id: "provide_reason" })}
                  name="reason"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "error.field_required",
                      }),
                    },
                  ]}
                >
                  <TextArea />
                </StyledFormItem>
              )}

              <StyledFormItem
                rules={[
                  {
                    required: true,
                    message: intl.formatMessage({
                      id: "error.field_required",
                    }),
                  },
                ]}
                label={intl.formatMessage({ id: "withdrawn_by" })}
                name="withdrawnBy"
              >
                <StyledInput
                  placeholder={intl.formatMessage({ id: "withdrawn_by" })}
                />
              </StyledFormItem>

              <StyledFormItem
                label={intl.formatMessage({ id: "email" })}
                name="email"
                rules={[
                  {
                    required: true,
                    message: intl.formatMessage({
                      id: "error.field_required",
                    }),
                  },
                  {
                    type: "email",
                    message: intl.formatMessage({
                      id: "error.valid_email",
                    }),
                  },
                ]}
              >
                <StyledInput
                  placeholder={intl.formatMessage({ id: "email" })}
                />
              </StyledFormItem>

              <Flex gap="8px" items="end" justify="flex-start">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "8px",
                  }}
                >
                  <TelephoneSpan>
                    {intl.formatMessage({ id: "telephone" })}
                    <span className="required">*</span>
                  </TelephoneSpan>
                  <StyledFormItem
                    name="ddi"
                    noStyle
                    rules={[
                      {
                        required: true,
                        message: intl.formatMessage({
                          id: "error.field_required",
                        }),
                      },
                    ]}
                  >
                    <StyledDDISelect
                      showSearch
                      optionLabelProp="label"
                      dropdownMatchSelectWidth={340}
                      placeholder="DDI"
                      filterOption={(input, option) => {
                        const searchTerm = input
                          .toLowerCase()
                          .replace(/[+\s-]/g, "");

                        const optionValue = (option?.filterLabel || "")
                          .toLowerCase()
                          .replace(/[+\s-]/g, "");

                        return optionValue.includes(searchTerm);
                      }}
                    >
                      {countryList.map((country) => {
                        const Flag = flags[country.countryCode];
                        return (
                          <Option
                            key={country.key}
                            value={country.value}
                            filterLabel={country.label}
                            label={
                              <FlagOption>
                                {Flag && <Flag title={country.name} />}
                                {country.value}
                              </FlagOption>
                            }
                          >
                            <FlagOption>
                              {Flag && <Flag title={country.name} />}
                              {country.label}
                            </FlagOption>
                          </Option>
                        );
                      })}
                    </StyledDDISelect>
                  </StyledFormItem>
                </div>
                <StyledFormItem
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "error.field_required",
                      }),
                    },
                  ]}
                  name="telephone"
                  noStyle
                >
                  <StyledInput
                    style={{ flex: 1 }}
                    placeholder={`(DDD) + ${intl.formatMessage({
                      id: "telephone",
                    })}`}
                    as={ReactInputMask}
                    mask="(99) 99999-9999"
                    maskPlaceholder={null}
                    alwaysShowMask={false}
                  />
                </StyledFormItem>
              </Flex>
              <Form.Item shouldUpdate noStyle>
                {() => {
                  const message =
                    form.getFieldError("ddi")[0] ||
                    form.getFieldError("telephone")[0];
                  return message ? (
                    <PhoneErrorText>{message}</PhoneErrorText>
                  ) : null;
                }}
              </Form.Item>
            </Form>
          )}
          <FooterContainer>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              {currentStep > 1 && (
                <img
                  onClick={() => setCurrentStep(currentStep - 1)}
                  src={back}
                  alt="back"
                  style={{ cursor: "pointer" }}
                />
              )}
              <span className="steps">{`${currentStep} ${intl.formatMessage({
                id: "of",
              })} 2`}</span>
            </div>

            <div style={{ marginRight: "10px" }}>
              <ButtonFormConfirm
                onClick={() => {
                  reset();
                  setOpen(false);
                }}
                style={{ border: "none" }}
              >
                {intl.formatMessage({ id: "cancel" })}
              </ButtonFormConfirm>
              <ButtonFormConfirm
                loading={loading}
                onClick={() =>
                  currentStep === 2
                    ? form.submit()
                    : setCurrentStep(currentStep + 1)
                }
                style={{
                  backgroundColor: "rgba(6, 142, 195, 1)",
                  color: "rgba(255, 255, 255, 1)",
                }}
              >
                {intl.formatMessage({ id: "confirm" })}
              </ButtonFormConfirm>
            </div>
          </FooterContainer>
        </div>
      )}

      {isDefaulter && (
        <ConfirmationModalContent
          description={intl.formatMessage({ id: "credential_locked" })}
          confirmationText="open_exception"
          cancelText="close"
          confirmationFunction={handleDefaulterConfirmation}
          cancelFunction={handleCloseModal}
        />
      )}
    </ModalWithdrawalAndDisassociate>
  );
}
